import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { headerTypographyProps } from '../styles/sxStyling';

interface DuplicateModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (name: string) => void;
  defaultName?: string;
  itemName: string;
}

export default function DuplicateModal({ isOpen, onCancel, onConfirm, defaultName = '', itemName }: DuplicateModalProps) {
  const [name, setName] = useState(defaultName);

  useEffect(() => {
    setName(defaultName);
  }, [isOpen, defaultName]);

  return (
    <Dialog open={isOpen} onClose={onCancel} fullWidth>
      <DialogTitle>
        <Typography {...headerTypographyProps}>Duplicate {itemName}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Please enter a name for the duplicated {itemName}.
        </Typography>
        <TextField
          fullWidth
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>      
        <Button variant="contained" onClick={() => onConfirm(name)} disabled={!name.trim()}>
          Duplicate
        </Button>
      </DialogActions>
    </Dialog>
  );
}
